function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { ExchangeID } from "TradeAPILib";
var KEY_ACCOUNT_INFO = "key_account_info";
var KEY_TRADE_SELECTED_API_KEY_ID = "key_trade_selected_api_key_id";
var KEY_SELECTED_EXCHANGE_PAIR = "key_selected_exchange_pair";
var KEY_GRID_PRICE_INTERVAL_TYPE = "key_grid_price_interval_type";
var KEY_GRID_USE_MY_ANOTHER_COIN = "key_grid_use_my_another_coin";
var KEY_GRID_SLIPPAGE_CONTROL = "key_grid_slippage_control";
export var LocalStorageKey = /*#__PURE__*/function (LocalStorageKey) {
  LocalStorageKey["KEY_ACCOUNT_TOKEN"] = "key_account_token";
  LocalStorageKey["KEY_ACCOUNT_INFO"] = "key_account_info";
  LocalStorageKey["KEY_TRADE_SELECTED_API_KEY_ID"] = "key_trade_selected_api_key_id";
  LocalStorageKey["KEY_TRADE_SELECTED_SYMBOL"] = "key_trade_selected_route_path";
  LocalStorageKey["KEY_SELECTED_EXCHANGE_PAIR"] = "key_selected_exchange_pair";
  LocalStorageKey["KEY_TRADE_SYMBOL_SORT_METHOD"] = "key_trade_symbol_sort_method";
  LocalStorageKey["KEY_TRADE_CHART_RESOLUTION"] = "key_trade_chart_resolution";
  LocalStorageKey["KEY_TRADE_CHART_STYLE"] = "key_trade_chart_style";
  LocalStorageKey["KEY_THEME_THEME_NAME"] = "key_theme_theme_name";
  LocalStorageKey["KEY_THEME_TICKER_REVERSED"] = "key_theme_ticker_reversed";
  LocalStorageKey["KEY_GRID_PRICE_INTERVAL_TYPE"] = "key_grid_price_interval_type";
  LocalStorageKey["KEY_GRID_USE_MY_ANOTHER_COIN"] = "key_grid_use_my_another_coin";
  LocalStorageKey["KEY_GRID_SLIPPAGE_CONTROL"] = "key_grid_slippage_control";
  LocalStorageKey["HAD_OPEN_GRID_FUTURE_ORDER"] = "HAD_OPEN_GRID_FUTURE_ORDER";
  LocalStorageKey["KEY_SHOW_BIND_GOOGLE_AUTH_DIALOG"] = "key_show_bind_google_auth_dialog";
  LocalStorageKey["CONFIG_LOCALE"] = "LANGUAGE_DATA_TYPE";
  LocalStorageKey["LOCALE_DATA"] = "locale_data";
  LocalStorageKey["KEY_BALANCE_DW_COINS"] = "key_balance_deposit_coin";
  LocalStorageKey["KEY_REFERRAL_INFO"] = "key_referral_info";
  LocalStorageKey["KEY_GRID_PROFIT_EXACT_POP"] = "key_show_grid_profit_exact";
  LocalStorageKey["KEY_ANNOUNCEMENT"] = "key_announcement";
  LocalStorageKey["KEY_TV_DEFAULT_INTERVAL"] = "key_tv_default_interval";
  LocalStorageKey["KEY_TV_CHART_STATE"] = "key_tv_chart_state";
  LocalStorageKey["KEY_TV_CHART_ADDED_MA_LINES"] = "key_tv_chart_added_ma_lines";
  LocalStorageKey["KEY_TV_CHART_SHOW_ORDER_LINES"] = "key_tv_chart_show_order_lines";
  LocalStorageKey["KEY_TV_CHART_PRO_FLAG"] = "key_tv_chart_pro_flag";
  LocalStorageKey["KEY_SMART_TRADE_TRAILING_SWITCH"] = "key_smart_trade_trailing_switch";
  LocalStorageKey["KEY_USER_HAVE_DEPOSIT_HISTORY"] = "key_user_have_deposit_history";
  LocalStorageKey["FSA_ADVANCED_SETTING"] = "fsa_advanced_setting";
  LocalStorageKey["FSA_REDUCE_POSITION_ADVANCED_SETTING"] = "fsa_reduce_position_advanced_setting";
  LocalStorageKey["FSA_CLOSE_POSITION_ADVANCED_SETTING"] = "fsa_close_position_advanced_setting";
  LocalStorageKey["KEY_DEFAULT_ACCOUNT_TYPE"] = "key_default_account_type";
  LocalStorageKey["KEY_DEFAULT_PHONE_AREA_COUNTRY"] = "key_default_phone_area_country";
  LocalStorageKey["KEY_DEFAULT_PHONE_AREA_CODE"] = "key_default_phone_area_code";
  LocalStorageKey["KEY_SUPPORT_LOCALE_KO"] = "key_support_locale_ko";
  LocalStorageKey["KEY_FP_DID"] = "key_fp_did";
  LocalStorageKey["KEY_TRADE_CONFIGURE"] = "KEY_TRADE_CONFIGURE";
  return LocalStorageKey;
}({});
var LocalStorageUtils = /*#__PURE__*/function () {
  function LocalStorageUtils() {
    _classCallCheck(this, LocalStorageUtils);
  }
  _createClass(LocalStorageUtils, null, [{
    key: "accountInfo",
    get: function get() {
      var accountInfoJson = window.localStorage.getItem(KEY_ACCOUNT_INFO);
      if (accountInfoJson && accountInfoJson !== "") {
        try {
          return _objectSpread(_objectSpread({}, JSON.parse(accountInfoJson)), {}, {
            isInitialized: true
          });
        } catch (error) {
          console.error(error);
        }
      }
      return undefined;
    }
  }, {
    key: "setSmartTradeTrailingSwitch",
    value: function setSmartTradeTrailingSwitch(value) {
      window.localStorage.setItem(LocalStorageKey.KEY_SMART_TRADE_TRAILING_SWITCH, value ? "true" : "");
    }
  }, {
    key: "smartTradeTrailingSwitch",
    get: function get() {
      return window.localStorage.getItem(LocalStorageKey.KEY_SMART_TRADE_TRAILING_SWITCH) ? true : false;
    }
  }, {
    key: "tradeSelectedApiKeyId",
    get: function get() {
      return window.localStorage.getItem(KEY_TRADE_SELECTED_API_KEY_ID);
    }
  }, {
    key: "selectedExchangePair",
    get: function get() {
      var data = window.localStorage.getItem(KEY_SELECTED_EXCHANGE_PAIR);
      if (!data) {
        return undefined;
      }
      try {
        var exchangePair = JSON.parse(data);
        if (exchangePair.exchange === ExchangeID.PIONEX) {
          exchangePair.exchange = ExchangeID.PIONEXV2;
        }
        return exchangePair;
      } catch (e) {
        console.error(e);
      }
      return undefined;
    }
  }, {
    key: "gridPriceIntervalType",
    get: function get() {
      var result = window.localStorage.getItem(KEY_GRID_PRICE_INTERVAL_TYPE);
      if (result) {
        return result;
      }
      return "arithmetic";
    },
    set: function set(type) {
      window.localStorage.setItem(KEY_GRID_PRICE_INTERVAL_TYPE, type);
    }
  }, {
    key: "gridSlippageControl",
    get: function get() {
      var result = window.localStorage.getItem(KEY_GRID_SLIPPAGE_CONTROL);
      return result !== null && result !== void 0 ? result : "";
    },
    set: function set(v) {
      window.localStorage.setItem(KEY_GRID_SLIPPAGE_CONTROL, v);
    }
  }, {
    key: "gridUseMyAnotherCoin",
    get: function get() {
      var result = window.localStorage.getItem(KEY_GRID_USE_MY_ANOTHER_COIN);
      if (result) {
        return result === "true";
      }
      return false;
    },
    set: function set(isUse) {
      window.localStorage.setItem(KEY_GRID_USE_MY_ANOTHER_COIN, isUse ? "true" : "false");
    }
  }, {
    key: "get",
    value: function get(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      window.localStorage.removeItem(key);
    }
  }, {
    key: "getBoolean",
    value: function getBoolean(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (defaultValue) {
        return LocalStorageUtils.get(key) !== "false";
      } else {
        return LocalStorageUtils.get(key) === "true";
      }
    }
  }, {
    key: "setBoolean",
    value: function setBoolean(key, value) {
      LocalStorageUtils.set(key, value ? "true" : "false");
    }
  }, {
    key: "getObject",
    value: function getObject(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = this.get(key);
      if (!data) {
        return defaultValue;
      }
      try {
        return JSON.parse(data);
      } catch (e) {}
      return defaultValue;
    }
  }, {
    key: "setObject",
    value: function setObject(key, value) {
      if (typeof value !== "boolean" && (!value || _typeof(value) !== "object")) {
        this.remove(key);
        return;
      }
      this.set(key, JSON.stringify(value));
    }
  }]);
  return LocalStorageUtils;
}();
export { LocalStorageUtils as default };